import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CinchCardHeroComponent } from './cinch-card-hero/cinch-card-hero.component';
import { CinchCardComponent } from './cinch-card/cinch-card.component';
import { PrimeNGModule } from '../prime-ng.module';
import { CinchCardSecondaryComponent } from './cinch-card-secondary/cinch-card-secondary.component';
import { CinchCardAccordionComponent } from './cinch-card-accordion/cinch-card-accordion.component';



@NgModule({
  declarations: [
    CinchCardHeroComponent,
    CinchCardComponent,
    CinchCardSecondaryComponent,
    CinchCardAccordionComponent
  ],
  imports: [
    CommonModule,
    PrimeNGModule
  ],
  exports: [
    CinchCardHeroComponent,
    CinchCardComponent,
    CinchCardSecondaryComponent,
    CinchCardAccordionComponent
  ]
})
export class CardsModule { }
